import flatMap from 'lodash/flatMap';

import GraphicalOutputs from '../../containers/GraphicalOutputs';

import buildDefaultLayout from './buildDefaultLayout';
import {
  configToGoldenLayoutItems,
  getBottomStack,
  getComponent,
} from './layoutBuilder';
import { defaultSettings } from './layoutsettings';

/**
 * "Normal layout" was created for the first exercises.
 * It's mainly about layout. Some exercises may have a layout very similar
 * to this one but needed some variations.
 */
export default function buildNormalLayout(props: any) {
  const {
    chapter,
    exercise,
    onItemClosed,
    setActiveTab,
    startSession,
    user: { consoleTabs, editorTabs, graphicalTabs },
  } = props;

  if (!chapter.slides_link) {
    delete consoleTabs.slides;
  }

  const topLeftStack = configToGoldenLayoutItems(exercise.language)(
    'editorTabs',
    editorTabs,
    {},
    {
      html: GraphicalOutputs({
        category: 'editorTabs',
        key: 'html',
      }),
    },
  );

  const topRightStack = flatMap(graphicalTabs, (tab, key) => {
    if (tab.props.sources.length <= 0) {
      return [];
    }
    return [
      {
        key,
        id: `graphical-${key}`,
        type: 'react-component',
        component: `graphical-${key}`,
        title: tab.title,
        isClosable: false,
        parentKey: 'graphicalTabs',
        reactComponent: getComponent(exercise.language)(key),
        props: {
          tabCategory: 'graphicalTabs',
          tabKey: key,
        },
      },
    ];
  });

  const bottomStack = getBottomStack(exercise.language)({
    ...props,
    onReconnect: () => startSession(true),
  });

  return {
    ...defaultSettings,
    content: [
      buildDefaultLayout({
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ key: string; id: string; type: string; com... Remove this comment to see the full error message
        topLeftStack,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ key: string; id: string; type: string; com... Remove this comment to see the full error message
        topRightStack,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ key: string; id: string; type: string; com... Remove this comment to see the full error message
        bottomStack,
        setActiveTab,
        onItemClosed,
      }),
    ],
  };
}
